/**
 * Карточка AI & Automation.
 */

import Typewriter from "../Typewriter/Typewriter";
import ServiceCard from "../ServiceCard/ServiceCard";
import IconAi from "../../assets/icons/IconAi";
import { SERVICE_AI } from "../../config/services";

function AiCard() {
    const copy = SERVICE_AI;

    return (
        <ServiceCard variant="ai">
            <div className="ai-card-header">
                <span className="ai-status-text">LIVE</span>
                <div className="ai-status-dots">
                    <span className="ai-status-dot"></span>
                    <span className="ai-status-dot"></span>
                    <span className="ai-status-dot"></span>
                </div>
            </div>
            <div className="ai-card-body">
                <div className="ai-icon-glow">
                    <IconAi />
                </div>
                <h3 className="group-9__title group-9__title_ai">
                    <Typewriter text={copy.title} speed={copy.titleSpeed} delay={copy.titleDelay} />
                </h3>
                <p className="group-9__text group-9__text_ai">
                    <Typewriter text={copy.text} speed={copy.textSpeed} delay={copy.textDelay} />
                </p>
                <div className="ai-progress-bars">
                    {copy.bars.map((bar) => (
                        <div className="ai-progress-item" key={bar.label}>
                            <span className="ai-progress-label">{bar.label}</span>
                            <div className="ai-progress-bar">
                                <div className="ai-progress-fill" style={{width: bar.width}}></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </ServiceCard>
    );
}

export default AiCard;
// components/ServiceCards/AiCard.js
